import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {TheRaveSound} from "../../sound/TheRaveSound";
import {TheRave} from "../../TheRave";

export class ReelStopSoundController extends ReelStopPresentationController {
    constructor() {
        super('ReelStopSoundController');
    }
    protected async onReelBounce(data: IReelStateEventData): Promise<any> {
        if(data.reelId<5){
            if(TheRave.model.parsedGameData.firstLinkedReelId>-1){
                if(data.reelId === TheRave.model.parsedGameData.firstLinkedReelId){
                    TheRaveSound.playSoundEffect("sidechainLanding");
                    TheRaveSound.stopSoundEffect("sidechainAirLoop");
                }else if(data.reelId<TheRave.model.parsedGameData.firstLinkedReelId || data.reelId>TheRave.model.parsedGameData.firstLinkedReelId){
                    TheRaveSound.playSoundEffect(TheRaveSound.REELS_LANDING[data.reelId]);
                }
            }else{
                TheRaveSound.playSoundEffect(TheRaveSound.REELS_LANDING[data.reelId]);
            }
        }
        if( data.reelId>4 && TheRave.model.parsedGameData.enhancerReel[data.reelId-5]){
            TheRaveSound.playSoundEffect(TheRaveSound.REELS_LANDING[data.reelId]);
        }
        if(data.reelId === 4 && TheRave.model.parsedGameData.nearWinReels.indexOf(true)>-1){
            TheRave.nearwinPresentation.stopAnticipationSound();
        }
        return super.onReelBounce(data);
    }

    protected onReelStopped(data: IReelStateEventData): Promise<void> {
        if (data.reelId === TheRave.model.parsedGameData.lastSpinReelId) {
            TheRaveSound.stopSoundEffect(TheRaveSound.REELS_SPINNING);
            if(this.isSkip){
                TheRaveSound.stopSoundEffect("scatterRespin");
            }
            TheRaveSound.stopSoundEffect("scatterAnticipation");
        }
        return super.onReelStopped(data);
    }
}